import api from "../api";

export async function getUserData(numSerie) {   // quando for requisição pra servidor sempre usar async
  return api.get(`atendimento/info/user/${numSerie}`);
}




